import { mapState } from "vuex"

export default {
  computed: {
    ...mapState(['form','DaDataToken','DaDataUrl'])
  },
  methods: {
    async dadataSuggest(query){
      let url = this.DaDataUrl,
          token = this.DaDataToken,
          options =  {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": "Token " + token
            },
            body: JSON.stringify({
              query: query, 
              count: 5,
              "locations": [{"country": "Россия"}]
            })
          }
      let sg = await (fetch(url, options)
                        .then(response => response.json())
                        .then(res=> res.suggestions.filter(el=>el.data && el.data.city_kladr_id))
                        .catch(()=>[]))
      return sg.map(el=>el.value)
    },
  },
}